// utils/constants.js

// API Base URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
export const API_BASE_URL_ELECTIONS = process.env.REACT_APP_API_URL_ELECTIONS || '';

// User Roles - ✅ Match exactly what backend sends
export const USER_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN',  // ✅ Changed from ADMIN
  SUB_ADMIN: 'SUB_ADMIN',
  USER: 'USER'
};

export const RESOURCE_TYPES = {
  HOST: 'HOST',
  CONTEST: 'CONTEST',
  CATEGORY: 'CATEGORY',
  CONTESTANT: 'CONTESTANT',
  ALL: 'ALL'
};

export const PERMISSION_ACTIONS = {
  VIEW: 'canView',
  CREATE: 'canCreate',
  EDIT: 'canEdit',
  DELETE: 'canDelete',
  MANAGE_ALL: 'canManageAll'  
};

// Approval Status
export const APPROVAL_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
};

// Contest Status
export const CONTEST_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  ENDED: 'ENDED'
};

// Vote Status
export const VOTE_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

// Payment Status
export const PAYMENT_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

// Payment Method
export const PAYMENT_METHOD = {
  PAYSTACK: 'PAYSTACK',
  MANUAL: 'MANUAL'
};

// Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE = 1;

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'nfa_token',
  USER: 'nfa_user'
};